export default __webpack_public_path__ + "static/media/new-twi.66294010.svg";